'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chatheader = require('./chatheader');

var _chatbody = require('./chatbody');

var _chatbody2 = _interopRequireDefault(_chatbody);

var _chatfooter = require('./chatfooter');

var _chatfooter2 = _interopRequireDefault(_chatfooter);

var _chatminimizedicon = require('./chatminimizedicon');

var _chatminimizedicon2 = _interopRequireDefault(_chatminimizedicon);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MOBILE_DEVICE = "mobile";
var DESKTOP_DEVICE = "desktop";
var VISIBILITY_SHOW = "show";
var VISIBILITY_HIDE = "hide";

var ChatRenderer = function (_Component) {
    _inherits(ChatRenderer, _Component);

    function ChatRenderer(props) {
        _classCallCheck(this, ChatRenderer);

        var _this = _possibleConstructorReturn(this, (ChatRenderer.__proto__ || Object.getPrototypeOf(ChatRenderer)).call(this, props));

        _this.state = {
            deviceMode: '', //mobile or desktop
            messageContainerHeight: {
                height: props.height,
                maxHeight: '350px',
                marginTop: '5px'
            },
            deviceScreenHeight: '0px',
            minimizeMaximizeIconCssClassName: "fa icon_minim fa-minus",
            minimizeMaximizeCurrentState: 1,
            chatWidgetCssClassName: 'chat-widget right-bottom',
            width: props.width,
            deviceScreenWidth: props.width,
            expandButtonCurrentState: 1,
            chatWidgetPosition: props.position,
            // messageReceiveContainerCss: 'col-xs-10 col-md-10 no-padding',
            // messageSentContainerCss: 'col-xs-10 col-md-10 no-padding',
            dropDownOptionIonCss: 'dropdown-menu-left',
            defaultChatBoxMode: props.displayMode,
            stickyCSS: ''
        };
        _this.minimizeChatBox = _this.minimizeChatBox.bind(_this);
        _this.maximizeChatbox = _this.maximizeChatbox.bind(_this);
        _this.fullscreenChatbox = _this.fullscreenChatbox.bind(_this);
        _this.hideChatBox = _this.hideChatBox.bind(_this);
        _this.showChatBox = _this.showChatBox.bind(_this);
        _this.onMinimizeButtonClick = _this.onMinimizeButtonClick.bind(_this);
        _this.onExpandButtonClick = _this.onExpandButtonClick.bind(_this);
        return _this;
    }

    _createClass(ChatRenderer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.innerWidth < 767) {
                this.setState({
                    deviceMode: MOBILE_DEVICE,
                    messageContainerHeight: {
                        height: window.innerHeight - 73 + 'px',
                        maxHeight: window.innerHeight - 73 + 'px',
                        marginTop: '42px'
                    },
                    deviceScreenHeight: window.innerHeight - 73 + 'px',
                    dropDownOptionIonCss: 'dropdown-menu-right',
                    stickyCSS: 'stickyheader',
                    deviceScreenWidth: window.innerWidth + 'px'
                });
            } else {
                this.setState({
                    deviceMode: DESKTOP_DEVICE,
                    // messageContainerHeight: {
                    //     height: '0px',
                    //     maxHeight: '0px',
                    //     marginTop: '0px'
                    // },
                    deviceScreenHeight: this.props.height,
                    dropDownOptionIonCss: 'dropdown-menu-left',
                    stickyCSS: ''
                });
            }
        }
    }, {
        key: 'updateChatWindow',
        value: function updateChatWindow(displayMode) {
            switch (displayMode) {
                case Constants.CHAT_WINDOW_STATE_MINIMIZED:
                    this.minimizeChatBox();
                    console.log("minimize");
                    break;

                case Constants.CHAT_WINDOW_STATE_NORMAL:
                    this.maximizeChatbox();
                    console.log("maximize");
                    break;

                case Constants.CHAT_WINDOW_STATE_ICON:
                    console.log("Icon");
                    break;

                case Constants.CHAT_WINDOW_STATE_FULLSCREEN:
                    this.fullscreenChatbox();
                    console.log("fullscreen");
                    break;

                default:
                    console.log("default");
                    return null;
            }
        }
    }, {
        key: 'onMinimizeButtonClick',
        value: function onMinimizeButtonClick() {
            switch (this.state.minimizeMaximizeCurrentState) {
                case 1:
                    this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_MINIMIZED);
                    // this.props.callBackFunction.updatedisplayMode()
                    break;

                case 2:
                    this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_NORMAL);
                    // this.props.callBackFunction.updatedisplayMode()
                    break;

                default:
                    break;
            }
        }
    }, {
        key: 'onExpandButtonClick',
        value: function onExpandButtonClick() {
            switch (this.state.expandButtonCurrentState) {
                case 1:
                    this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_FULLSCREEN);
                    // this.props.callBackFunction.updatedisplayMode()
                    break;

                case 2:
                    this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_NORMAL);
                    // this.props.callBackFunction.updatedisplayMode()
                    break;

                default:
                    break;
            }
        }
    }, {
        key: 'minimizeChatBox',
        value: function minimizeChatBox() {
            if (this.state.deviceMode === MOBILE_DEVICE && this.props.callBackFunction) {
                // this.props.callBackFunction.ToggleHomePage(VISIBILITY_SHOW)
            }
            this.setState({
                chatWidgetCssClassName: 'chat-widget ' + this.state.chatWidgetPosition,
                messageContainerHeight: {
                    height: "0px",
                    maxHeight: "0px",
                    marginTop: '0px'
                },
                defaultChatBoxMode: Constants.CHAT_WINDOW_STATE_ICON,
                minimizeMaximizeIconCssClassName: "fa fa-plus icon_minim panel-collapsed",
                minimizeMaximizeCurrentState: 2,
                expandButtonCurrentState: 1
            });
        }
    }, {
        key: 'maximizeChatbox',
        value: function maximizeChatbox() {
            var marginTop = this.state.deviceMode === MOBILE_DEVICE ? '42px' : '0px';
            var screenheight = this.state.deviceMode === MOBILE_DEVICE ? '100vh' : this.props.height;
            if (this.state.deviceMode === MOBILE_DEVICE && this.props.callBackFunction) {
                // this.props.callBackFunction.ToggleHomePage(VISIBILITY_HIDE)
            }
            this.setState({
                chatWidgetCssClassName: 'chat-widget ' + this.state.chatWidgetPosition,
                messageContainerHeight: {
                    height: screenheight,
                    maxHeight: screenheight,
                    marginTop: marginTop
                },
                width: this.state.deviceScreenWidth,
                defaultChatBoxMode: Constants.CHAT_WINDOW_STATE_NORMAL,
                minimizeMaximizeIconCssClassName: "fa icon_minim fa-minus",
                minimizeMaximizeCurrentState: 1,
                expandButtonCurrentState: 1
            });
        }
    }, {
        key: 'fullscreenChatbox',
        value: function fullscreenChatbox() {
            var marginTop = this.state.deviceMode === MOBILE_DEVICE ? '42px' : '0px';
            this.setState({
                chatWidgetCssClassName: 'chat-widget fullscreen ' + this.state.chatWidgetPosition,
                messageContainerHeight: {
                    height: window.innerHeight - 88 + 'px',
                    maxHeight: window.innerHeight - 88 + 'px',
                    marginTop: marginTop
                },
                width: window.innerWidth + 'px',
                expandButtonCurrentState: 2,
                defaultChatBoxMode: Constants.CHAT_WINDOW_STATE_NORMAL,
                // messageReceiveContainerCss: 'col-xs-10 col-md-7 no-padding',
                // messageSentContainerCss: 'col-md-7 col-md-offset-5 col-xs-10 no-padding',
                minimizeMaximizeIconCssClassName: "fa icon_minim fa-minus",
                minimizeMaximizeCurrentState: 1
            });
        }

        // onInputBoxClick() {
        //     this.setState({
        //         messageContainerHeight: {
        //             height: this.state.deviceScreenHeight,
        //             maxHeight: this.state.deviceScreenHeight,
        //             marginTop: this.state.marginTop
        //         },
        //     })
        // }

    }, {
        key: 'hideChatBox',
        value: function hideChatBox() {
            if (this.state.deviceMode === MOBILE_DEVICE) {
                this.setState({
                    defaultChatBoxMode: Constants.CHAT_WINDOW_STATE_ICON
                });
                // this.props.callBackFunction.ToggleHomePage(VISIBILITY_SHOW)
                this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_MINIMIZED);
            }
        }
    }, {
        key: 'showChatBox',
        value: function showChatBox() {
            if (this.state.deviceMode === MOBILE_DEVICE) {
                this.setState({
                    defaultChatBoxMode: Constants.CHAT_WINDOW_STATE_NORMAL,
                    messageContainerHeight: {
                        height: this.state.deviceScreenHeight,
                        maxHeight: this.state.deviceScreenHeight,
                        marginTop: '42px'
                    }
                });
                // this.props.callBackFunction.ToggleHomePage(VISIBILITY_HIDE)
                this.props.setDisplayMode(Constants.CHAT_WINDOW_STATE_NORMAL);
            } else {
                this.onMinimizeButtonClick();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.updateChatWindow(nextProps.displayMode);
        }
    }, {
        key: 'render',
        value: function render() {
            var chatbox = null;

            switch (this.state.defaultChatBoxMode) {
                case Constants.CHAT_WINDOW_STATE_NORMAL:
                    var chatHeader = this.props.showHeader === true ? _react2.default.createElement(_chatheader.ChatHeader, {
                        minimizeMaximizeIconCssClassName: this.state.minimizeMaximizeIconCssClassName,
                        onMinimizeButtonClick: this.onMinimizeButtonClick,
                        onExpandButtonClick: this.onExpandButtonClick,
                        dropDownOptionIonCss: this.state.dropDownOptionIonCss,
                        hideChatBox: this.hideChatBox,
                        stickyCSS: this.state.stickyCSS }) : null;

                    var chatBody = this.props.showBody === true ? _react2.default.createElement(_chatbody2.default, {
                        loader: this.props.isLoading,
                        user: this.props.user,
                        isMeetingEnded: this.props.isMeetingEnded,
                        messages: this.props.messages,
                        user_typing_messages: this.props.user_typing_messages,
                        participants: this.props.participants,
                        chatteeId: this.props.chatteeId,
                        messageContainerHeight: this.state.messageContainerHeight,
                        user_type: this.props.user_type,
                        chatElement: this.props.chatElement,
                        user_pic: this.props.user_pic,
                        nonWorkingHour: this.props.nonWorkingHour,
                        nonWorkingHourDisplayMessage: this.props.nonWorkingHourDisplayMessage,
                        loadHistoryMessages: this.props.loadHistoryMessages,
                        loadParticipantList: this.props.loadParticipantList,
                        mask_user_events: this.props.mask_user_events,
                        mask_user_typing_text: this.props.mask_user_typing_text,
                        setTypingMessage: this.props.setTypingMessage,
                        historyMessagesUrl: this.props.historyMessagesUrl }) : null;

                    var chatFooter = this.props.showFooter === true ? _react2.default.createElement(_chatfooter2.default, {
                        onMessageEntered: this.props.onMessageEntered,
                        isMeetingEnded: this.props.isMeetingEnded,
                        nonWorkingHour: this.props.nonWorkingHour,
                        setLastTypedMessage: this.props.setLastTypedMessage,
                        lastTypedMessage: this.props.lastTypedMessage }) : null;

                    chatbox = _react2.default.createElement(
                        'div',
                        { className: this.state.chatWidgetCssClassName, style: { width: this.state.width }, id: 'chat_window' },
                        _react2.default.createElement(
                            'div',
                            { className: 'panel panel-default' },
                            chatHeader,
                            chatBody,
                            chatFooter
                        )
                    );
                    break;

                case Constants.CHAT_WINDOW_STATE_ICON:
                    chatbox = _react2.default.createElement(_chatminimizedicon2.default, {
                        showChatBox: this.showChatBox,
                        onMinimizeButtonClick: this.onMinimizeButtonClick,
                        messages: this.props.messages,
                        defaultChatBoxMode: this.state.defaultChatBoxMode,
                        unReadMessageCount: this.props.unReadMessageCount });
                    break;

                case Constants.CHAT_WINDOW_STATE_HIDE:
                    chatbox = null;
                    break;

                default:
                    return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'row jm_chat' },
                chatbox
            );
        }
    }]);

    return ChatRenderer;
}(_react.Component);

exports.default = ChatRenderer;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatrenderer.js